


































































import { defineComponent, onMounted, ref, watch, unref } from '@vue/composition-api';
import AdCampaign from '@/bundles/Ad/models/AdCampaign';
import { useAdCampaign } from '@/bundles/Ad/composables/useAdCampaign';
import { Nullable, VForm } from '@/bundles/App/type';
import { useAdClient } from '@/bundles/Ad/composables/useAdClient';
import { IAdCampaign } from '@/bundles/Ad/interfaces';

export default defineComponent({
  name: 'AdCampaignFormBase',

  emits: ['item:submit'],

  props: {
    adCampaignEntry: {
      type: AdCampaign,
      required: true,
    },
    saveLoadingEntry: Boolean,
    isEditForm: Boolean,
  },

  setup(props, { emit }) {
    const adCampaignForm = ref(null);
    const { adCampaign, statuses } = useAdCampaign();
    const adCampaignClient = ref<Nullable<number>>(null);
    function resetValidation () {
      if (!adCampaignForm.value) {
        return;
      }
      (adCampaignForm.value as unknown as VForm).resetValidation();
    }
    watch(() => props.adCampaignEntry, function () {
      adCampaign.value = { ...props.adCampaignEntry, client: { ...props.adCampaignEntry.client } };
      if (adCampaign.value.client.id !== 0) {
        adCampaignClient.value = adCampaign.value.client.id;
      }
      resetValidation();
    }, { deep: true, immediate: true });
    function submitEventHandler () {
      if (!(adCampaignForm.value as unknown as VForm).validate()) {
        return;
      }
      const plainObject = unref(adCampaign);
      const payload: Partial<IAdCampaign> & { client_id?: number } = {
        title: plainObject.title,
        description: plainObject.description,
        region: plainObject.region,
        status: plainObject.status
      };
      if (payload.client_id !== props.adCampaignEntry.client.id) {
        payload.client_id = adCampaignClient.value!;
      }
      if (props.isEditForm) {
        payload.id = plainObject.id;
        payload.active = plainObject.active;
      }
      emit('item:submit', payload);
    }
    const { adClientItems, fetch: fetchClients } = useAdClient();
    onMounted(async () => {
      await fetchClients();
    });

    return {
      adCampaign,
      adCampaignForm,
      adClientItems,
      adCampaignClient,
      statuses,
      submitEventHandler,
    };
  },
});
